import { FirstBuyTutorialLayer } from "./FirstBuyTutorialLayer";
import { MapsLayer } from "./map-layer/MapsLayer";
import { UpgradesLayer } from "./upgrades-layer/UpgradesLayer";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";
import { LobbyGUI } from "./LobbyGUI";
import { Title } from "./Title";
import { BootScene } from "../BootScene";

export class LobbyScene extends Phaser.Scene {

    public static currentInstance: LobbyScene;

    public background: Phaser.GameObjects.Image;
    public upgradesLayer: UpgradesLayer;

    private gui: LobbyGUI;
    private mapsLayer: MapsLayer;
    private swipeInput: any;

    constructor() {

        super("LobbyScene");

        LobbyScene.currentInstance = this;
    }

    public create(): void {

        GameVars.currentScene = this;

        this.cameras.main.setBackgroundColor(0x6cd9b2);

        let scaleX = (GameConstants.GAME_WIDTH - (280 * GameVars.scaleX)) / (GameConstants.GAME_WIDTH - 280);

        this.background = new Phaser.GameObjects.Image(this, 280 * GameVars.scaleX, 65, "background");
        this.background.setOrigin(0);
        this.background.setScale(scaleX, scaleX);
        this.add.existing(this.background);

        let count = 0;

        for (let i = 0; i < GameVars.gameData.progression.length; i++) {
            if (GameVars.gameData.progression[i].completed && i !== GameVars.gameData.progression.length - 1) {
                count++;
            }
        }

        this.background.x = 280 * GameVars.scaleX - 313 * scaleX * count;

        // ceiling
        const ceilLeft = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "ceiling_frame_left");
        ceilLeft.setOrigin(0);
        ceilLeft.scaleX = GameVars.scaleX;
        this.add.existing(ceilLeft);

        for (let i = 0; i < 7; i++) {

            const ceilMid = new Phaser.GameObjects.Image(this, ceilLeft.width * GameVars.scaleX, 0, "texture_atlas_1", "ceiling_frame_tile");
            ceilMid.setOrigin(0);
            ceilMid.scaleX = GameVars.scaleX;
            this.add.existing(ceilMid);

            ceilMid.x += ceilMid.width * GameVars.scaleX * i;
        }

        const ceilRight = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH, 0, "texture_atlas_1", "ceiling_frame_right");
        ceilRight.setOrigin(1, 0);
        ceilRight.scaleX = GameVars.scaleX;
        this.add.existing(ceilRight);

        this.mapsLayer = new MapsLayer(this);
        this.add.existing(this.mapsLayer);

        let title = new Title(this);
        this.add.existing(title);

        this.upgradesLayer = new UpgradesLayer(this);
        this.add.existing(this.upgradesLayer);

        this.gui = new LobbyGUI(this);
        this.add.existing(this.gui);

        const copyrightLabel1 = this.add.text(10, 10, "made by ravalmatic", { fontFamily: "Arial", fontSize: "18px", color: "#FFFFFF" });
        copyrightLabel1.alpha = .3;
        copyrightLabel1.scaleX = GameVars.scaleX;

        const copyrightLabel2 = this.add.text(10, 32, "licensed to " + GameConstants.SPONSOR, { fontFamily: "Arial", fontSize: "18px", color: "#FFFFFF" });
        copyrightLabel2.alpha = .3;
        copyrightLabel2.scaleX = GameVars.scaleX;

        copyrightLabel1.setVisible(false);
        copyrightLabel2.setVisible(false);

        if (GameVars.levelCompleted) {
            this.manageLevelCompleted();
        } else {
            if (!GameVars.gameData.initialTutorial && GameVars.gameData.buyTutorial) {
                LobbyScene.currentInstance.showTutorial();
            }
        }

        if (!this.sys.game.device.os.desktop) {

            this.input.on("pointerup", () => {

                if (!this.game.scale.isFullscreen) {
                    this.game.scale.startFullscreen();
                    BootScene.onOrientationChange();
                    // GameManager.enterLobbyScene();
                }
            }, this);
        }

        const scene = <any>this;

        this.swipeInput = scene.rexGestures.add.swipe();

        this.swipeInput.on("swipe", function (swipe) {

            if (swipe["left"]) {
                if (this.mapsLayer.rightButton.visible) {
                    this.mapsLayer.onClickRight();
                }
            }

            if (swipe["right"]) {
                if (this.mapsLayer.leftButton.visible) {
                    this.mapsLayer.onClickLeft();
                }
            }

        }, this);

        AudioManager.playSoundtrack("soundtrack_menus", .25);
    }

    public update(): void {

        this.upgradesLayer.update();
    }

    public showTutorial(): void {

        let firstBuyTutorial = new FirstBuyTutorialLayer(this);
        this.add.existing(firstBuyTutorial);
    }

    public scrollBackground(x: number): void {

        const scaleX = (GameConstants.GAME_WIDTH - (280 * GameVars.scaleX)) / (GameConstants.GAME_WIDTH - 280);

        this.tweens.add({
            targets: this.background,
            x: 280 * GameVars.scaleX + x * scaleX,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000
        });
    }

    public addHUDStar(x: number, y: number, numStars: number): void {

        this.upgradesLayer.addStar(x, y, numStars);
    }

    public scrollBack(): void {

        const scaleX = (GameConstants.GAME_WIDTH - (280 * GameVars.scaleX)) / (GameConstants.GAME_WIDTH - 280);
        this.background.x += 313 * scaleX;
    }

    public showTurretInfo(key: string, i: number, x: number, y: number): void {

        this.upgradesLayer.showTurretInfo(key, i, x, y);
    }

    public hideTurretInfo(): void {

        this.upgradesLayer.hideTurretInfo();
    }

    private manageLevelCompleted(): void {

        this.mapsLayer.kingHitTable();
        this.upgradesLayer.setPreviousStars();
        this.mapsLayer.showLevelCompleted();

        if (GameVars.levelCompleted.needUnlock) {
            this.mapsLayer.unlockNextLevel();
        }
    }
}
